import { render, staticRenderFns } from "./ChatDistributionsByUser.vue?vue&type=template&id=c0d4acd4&scoped=true"
import script from "./ChatDistributionsByUser.vue?vue&type=script&lang=js"
export * from "./ChatDistributionsByUser.vue?vue&type=script&lang=js"
import style0 from "./ChatDistributionsByUser.vue?vue&type=style&index=0&id=c0d4acd4&prod&lang=scss"
import style1 from "./ChatDistributionsByUser.vue?vue&type=style&index=1&id=c0d4acd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d4acd4",
  null
  
)

export default component.exports